import { Item } from "../../pojo/Item";
import type { AvailCheck } from "../../pojo/AvailabilityCheck";

import type { Layout } from "./s25.object.search.util";

export namespace ObjectSearchAvail {
    export type ItemType = Item.Ids.Location | Item.Ids.Resource;

    export function getAddedItemId(item: AddedItem): number {
        return "spaceId" in item ? item.spaceId : item.resourceId;
    }

    export interface AddedLocation {
        spaceId: number;
        spaceName?: string;
        share?: boolean;
        layouts?: Layout[];
        maxCapacity?: number;
        instructions?: string;
        checkedObj?: AvailCheck.CheckedObj;
    }

    export interface AddedResource {
        resourceId: number;
        resourceName?: string;
        /** requested quantity; maps to defaultResourceQuantity in angJS */
        quantity?: number;
        /** total quantity of the resource; maps to quantity in angJS */
        itemQuantity?: number;
        instructions?: string;
        checkedObj?: AvailCheck.CheckedObj;
        /** per-occurrence availability; all data is copied to each row */
        // TODO: store only the relevant info for this resource instead of the whole map
        allResAvailDateMap?: AvailCheck.ResAvailDateMap;
    }

    export type AddedItem = AddedLocation | AddedResource;
}
